// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1589434a","532":"c74ef94e","596":"b1a922f0","600":"7f04b1d1","681":"35248877"}[chunkId] + ".chunk.js";
};